import { queryStringToRecord } from '@/utils/query-string';

export function translateComplexKey(
  key: Nullable<string>,
  t: (key: string, params?: Record<string, unknown>) => string,
): string {
  if (!key) return '';
  if (key.startsWith('||')) {
    return key.replace('||', '');
  }
  if (key.includes('|')) {
    const [k = '', qs = ''] = key.split('|');
    const params = queryStringToRecord(qs);
    return t(k, params);
  }
  return t(key);
}
